import { escape } from 'lodash';

/**
 * Builds the points of a series, one per entity in `data`.
 *
 * Group value:
 * - `name` holds it escaped for HTML when it is a string, because Highcharts renders it as markup.
 * - `id` holds it as is, and is the key to match a point on.
 */
export function getSeriesData(param, data, groupBy, enableDrilldown) {
  const seriesData = [];

  for (const entityData of data) {
    const groupValue = entityData[groupBy];

    seriesData.push({
      y: entityData[param.name],
      name: typeof groupValue === 'string' ? escape(groupValue) : groupValue,
      id: groupValue,
      drilldown: !!enableDrilldown
    });
  }

  return seriesData;
}
